// @ts-nocheck
import React from "react";
import {
  Box,
  CircularProgress,
  Slide,
} from "@mui/material";
import { usePostOrg } from "../../../api/queries/usePostOrg.ts"; // Adjust the path as needed
import { H7TitleLarge } from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import CloseIcon from "@mui/icons-material/Close";
import { PoolConfiguration } from "./PoolConfiguration/PoolConfiguration.js";
import { PriceProfile } from "./priceProfile/priceProfile.js";
import { SiteDemand } from "./SiteDemand/SiteDemand.js";
import { AggregatedTHs } from "./AggregatedTHs/AggregatedTHs.js";
import { AggregatedPower } from "./AggregatedPower/AggregatedPower.js";
import { MinersHashing } from "./MinersHashing/MinersHashing.js";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import useSiteAndGroupTreeContext from "../../context/useSiteAndGroupTreeContext.js";
import {
  PostSiteView,
  PostDGView,
} from "../../../api/api.js";

import AuradineErrorState from "../../../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

export const RightSidePanel = (props) => {
  const {
    rightSidePanelOpen,
    setRightSidePanelOpen,
    height,
    gridRef,
  } = props;
  const { colors } = useTheme();
  const [authToken, setAuthToken] = React.useState("");
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();

  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();

  useEffect(() => {
    if (rightSidePanelOpen) {
      if (
        siteSelectedName === "" &&
        groupSelectedName === ""
      ) {
        setRightSidePanelOpen(false);
      }
    }
  }, [
    rightSidePanelOpen,
    siteSelectedName,
    groupSelectedName,
  ]);

  const projection =
    siteSelectedName !== "" && groupSelectedName === ""
      ? { [`siteConfig.${siteSelectedName}`]: 1 }
      : {
          [`siteConfig.${siteSelectedName}.devicegroupConfig.${groupSelectedName}`]: 1,
        };

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const siteOrGroupConfig = {};

  const {
    data: siteOrGroupConfigData,
    refetch: siteOrGroupConfigRefetch,
    isLoading: issiteOrGroupLoading,
    isFetching: isSiteOrGroupFetching,
    isFetched: isSiteOrGroupFetched,
  } = usePostOrg({
    open: rightSidePanelOpen,
    authToken,
    ...{
      projection: projection,
    },
  });

  const {
    data: siteView,
    isLoading: isSiteOrDGViewLoading,
    isFetching: isSiteOrDGViewFetching,
    isFetched: isSiteOrDGViewFetched,
  } = useQuery({
    queryKey: [
      "siteView",
      authToken,
      siteSelectedName,
      groupSelectedName,
    ],
    queryFn: () =>
      PostSiteView(authToken, {
        siteName: siteSelectedName,
      }),
    enabled: rightSidePanelOpen && !!authToken,
    refetchOnWindowFocus: false,
    staleTime: 0,
    cacheTime: 0,
    gcTime: 0,
  });

  console.log("siteview", siteView);

  // const poolCfg = siteView.config?.ztp?.poolCfg || [];

  const configData =
    siteView &&
    siteView.status === "ok" &&
    siteView.siteview &&
    Array.isArray(siteView.siteview)
      ? siteSelectedName !== "" && groupSelectedName === ""
        ? siteView.siteview[0]?.config?.ztp
        : siteView.siteview[0]?.config?.devicegroupConfig[
            groupSelectedName
          ]?.ztp
      : {};

  const poolCfg = configData?.poolCfg || [];

  console.log("poolCfg", poolCfg);

  const priceConfig =
    siteView &&
    siteView.siteview &&
    Array.isArray(siteView.siteview) &&
    siteView.siteview[0]
      ? {
          ...siteView?.siteview[0]?.priceConfig,
          configName:
            siteView?.siteview[0]?.priceConfigName,
        }
      : {};

  console.log(
    "dr",
    siteView?.siteview[0]?.demandResponseConfig
  );

  const demandResponseConfig =
    siteView &&
    siteView.siteview &&
    Array.isArray(siteView.siteview) &&
    siteView.siteview.length > 0 &&
    siteView.siteview[0]
      ? {
          ...siteView?.siteview[0]?.demandResponseConfig,
          configName:
            siteView?.siteview[0]?.demandResponseConfigName,
        }
      : {};

  const aggregatedTHs =
    siteView &&
    siteView.siteview &&
    Array.isArray(siteView.siteview) &&
    siteView.siteview.length > 0 &&
    siteView.siteview[0]
      ? {
          aggregatedTHsLastHour:
            siteView?.siteview[0]?.aggregatedTHsLastHour,
        }
      : {};
  const aggregatedPowerConsumption =
    siteView &&
    siteView.siteview &&
    Array.isArray(siteView.siteview) &&
    siteView.siteview.length > 0 &&
    siteView.siteview[0]
      ? {
          aggregatedPowerConsumptionLastHour:
            siteView?.siteview[0]
              ?.aggregatedPowerConsumptionLastHour,
        }
      : {};
  const minerHashingData =
    siteView &&
    siteView.siteview &&
    Array.isArray(siteView.siteview) &&
    siteView.siteview.length > 0 &&
    siteView.siteview[0]
      ? {
          totalHashingDevicesLastHour:
            siteView?.siteview[0]
              ?.totalHashingDevicesLastHour,
        }
      : {};

  console.log("demandResponseConfig", demandResponseConfig);

  console.log("siteview", siteView);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={4}
      width={rightSidePanelOpen ? "100%" : "0"} // Control width for transition
      flex={rightSidePanelOpen ? 1 : 0} // Control flex for smoother adjustment
      sx={{
        backgroundColor: colors.background.paper,
        padding: rightSidePanelOpen ? "0.75rem" : "0", // Adjust padding for closed state
        borderRadius: "1rem", // Hide overflow to avoid content showing while closing
      }}
      flexGrow={1}
    >
      <Box
        display="flex"
        flexDirection={"column"}
        flexGrow={1}
        height={height}
      >
        {rightSidePanelOpen &&
          isSiteOrDGViewLoading &&
          isSiteOrDGViewFetching &&
          !isSiteOrDGViewFetched && (
            <Box
              display={"flex"}
              justifyContent="center"
              alignItems="center"
              flexGrow={1}
            >
              <CircularProgress
                size="2rem"
                sx={{ color: colors.primary.main }}
              />
            </Box>
          )}
        {rightSidePanelOpen &&
          siteView &&
          siteView.status === "ok" && (
            <>
              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                sx={{
                  top: 0,
                  position: "sticky",
                  zIndex: 1,
                }}
                flexShrink={0}
              >
                <H7TitleLarge>
                  Site Configurations
                </H7TitleLarge>
                <StyledIconButton
                  colors={colors}
                  onClick={() => {
                    setRightSidePanelOpen(false);
                    if (gridRef.current) {
                      gridRef.current = null;
                    }
                  }}
                >
                  <CloseIcon
                    fontSize={"medium"}
                  />
                </StyledIconButton>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                sx={{
                  flexGrow: 1, // Allow content to grow and fill remaining space
                  overflow: "auto", // Apply scrolling only to this box
                  maxHeight: height * 0.95,
                  // Adjust max height if necessary
                }}
              >
                <PoolConfiguration
                  poolConfigurationData={poolCfg}
                  isLoading={
                    isSiteOrDGViewLoading ||
                    isSiteOrDGViewFetching
                  }
                  isFetched={isSiteOrDGViewFetched}
                />
                <PriceProfile
                  priceProfileData={priceConfig}
                  isLoading={
                    isSiteOrDGViewLoading ||
                    isSiteOrDGViewFetching
                  }
                  isFetched={isSiteOrDGViewFetched}
                />
                <SiteDemand
                  siteDemandData={demandResponseConfig}
                  isLoading={
                    issiteOrGroupLoading ||
                    isSiteOrGroupFetching
                  }
                  isFetched={isSiteOrGroupFetched}
                />

                <AggregatedTHs
                  hashRateData={aggregatedTHs}
                  isLoading={
                    issiteOrGroupLoading ||
                    isSiteOrGroupFetching
                  }
                  isFetched={isSiteOrGroupFetched}
                />
                <AggregatedPower
                  powerData={aggregatedPowerConsumption}
                  isLoading={
                    issiteOrGroupLoading ||
                    isSiteOrGroupFetching
                  }
                  isFetched={isSiteOrGroupFetched}
                />
                <MinersHashing
                  minerHashingData={minerHashingData}
                  isMinersHashingDataLoading={
                    issiteOrGroupLoading ||
                    isSiteOrGroupFetching
                  }
                  isFetched={isSiteOrGroupFetched}
                />
              </Box>
            </>
          )}
        {rightSidePanelOpen &&
          (!siteView || siteView.status !== "ok") &&
          isSiteOrDGViewFetched &&
          !isSiteOrDGViewFetching &&
          !isSiteOrDGViewLoading && (
            <>
              <AuradineErrorState
                message={
                  siteView?.msg ||
                  "An error occurred while fetching site view data."
                }
                fontSize="1rem"
              />
            </>
          )}
      </Box>
    </Box>
  );
};
